import { render, staticRenderFns } from "./MenuCommon.vue?vue&type=template&id=5efddfab&scoped=true"
import script from "./MenuCommon.vue?vue&type=script&lang=js"
export * from "./MenuCommon.vue?vue&type=script&lang=js"
import style0 from "./MenuCommon.vue?vue&type=style&index=0&id=5efddfab&lang=scss&scoped=true"
import style1 from "./MenuCommon.vue?vue&type=style&index=1&id=5efddfab&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efddfab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5efddfab')) {
      api.createRecord('5efddfab', component.options)
    } else {
      api.reload('5efddfab', component.options)
    }
    module.hot.accept("./MenuCommon.vue?vue&type=template&id=5efddfab&scoped=true", function () {
      api.rerender('5efddfab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/advancecomponets/children/MenuCommon.vue"
export default component.exports